import { useMutation } from "@apollo/client/react";
import { Box, Flex, Heading2, LoadingAnimation, Text, Toggle } from "@nulogy/components";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import GetApplicationContext from "hooks/apollo/applicationContext/applicationContext.gql";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import UpdateUserPreferences from "hooks/apollo/user/userPreferences.gql";
import { useNotificationState, useSchedulerState } from "hooks/state";
import React from "react";
import styled from "styled-components";

const Description = styled(Text)`
  margin-left: 56px;
`;

export default function UserPreferences() {
  const { user } = useApplicationContext();
  const [updateUserPreferencesMutation, { loading }] = useMutation(UpdateUserPreferences);
  const { extendedViewChanged } = useSchedulerState();
  const { setNotification } = useNotificationState();

  const updateUserPreferences = () => {
    const toValue = !user.userPreferences.extendedView;

    updateUserPreferencesMutation({
      onCompleted: () => {
        extendedViewChanged({ extendedView: toValue });
        setNotification({ message: "Preferences updated", type: "success" });
      },
      refetchQueries: [{ query: GetApplicationContext }],
      variables: { extendedView: toValue },
    });
  };

  if (!user) return <LoadingAnimation />;

  return (
    <PageWithBreadcrumbs title="Preferences">
      <Flex justifyContent="center" width="100%">
        <Box boxShadow="small" p="x2" width="720px">
          <Heading2>Schedule</Heading2>
          <Toggle
            disabled={loading}
            offText="Extended view"
            onClick={updateUserPreferences}
            onText="Extended view"
            toggled={user.userPreferences.extendedView}
          />
          <Description disabled={loading} fontSize="small">
            This enables you to scroll indefinitely on the schedule.
          </Description>
        </Box>
      </Flex>
    </PageWithBreadcrumbs>
  );
}
